import { createFileRoute } from "@tanstack/react-router";
import { SavedPage } from "../features/pins/SavedPage";

export const Route = createFileRoute("/w/$ws/saved")({ component: SavedPage });
